import { render, staticRenderFns } from "./FlightsListItemLeg.vue?vue&type=template&id=1fc1a85a"
import script from "./FlightsListItemLeg.vue?vue&type=script&lang=js"
export * from "./FlightsListItemLeg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsListItemLegDivider: require('/home/forge/ab.farescraper.com/components/FlightsListItemLegDivider.vue').default})
